module.exports = __webpack_public_path__ + "static/media/sanitary.ae47d969.jpg";